import { render } from "./FooterV.vue?vue&type=template&id=c2384c8c&scoped=true"
import script from "./FooterV.vue?vue&type=script&lang=js"
export * from "./FooterV.vue?vue&type=script&lang=js"

import "./FooterV.vue?vue&type=style&index=0&id=c2384c8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2384c8c"]])

export default __exports__